import React from 'react'
import './RestaurantLogo.css'
import { ReactNode } from "react";
import PropTypes from 'prop-types'

const RestaurantLogo = ({ link, restaurants, children, image, isActive, onClick }) => {
    return (
        <div className="restaurant" onClick={onClick}>
            <div className="restaurant-image">
                {React.cloneElement(image, { className: isActive ? 'active' : '' })}
            </div>
            {/* <h2 className="restaurant-info">
                {restaurants}
                {children}
            </h2> */}
        </div>
    )
}

RestaurantLogo.propTypes = {
    link: PropTypes.string,
    restaurants: PropTypes.string,
    children: PropTypes.node,
    image: PropTypes.node.isRequired,
};

export default RestaurantLogo
